export default () => {
  const maps = document.querySelector('.js-maps')
  if (!maps) return

  const script = document.createElement('script')
  script.src = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyCuEyJ3NxWYBbWt766rzZS0tWEpuKcjfLY&callback=mapsCallback`
  document.body.appendChild(script)

  window.mapsCallback = () => {
    displayMaps()
  }

  const displayMaps = () => {
    const coordinates = {
      lat: 52.3938855,
      lng: 4.8486208
    }
    const options = {
      zoom: 16,
      center: new window.google.maps.LatLng(coordinates.lat, coordinates.lng),
      scrollwheel: false,
      draggable: false,
      zoomControl: false,
      scaleControl: false
    }
    const map = new window.google.maps.Map(document.getElementById('maps'), options)
    return new window.google.maps.Marker({
      map,
      position: coordinates
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/Maps.js